import { Typography } from '@mui/material'
import { useEffect } from 'react'
import EventsEngine from '../../engines/EventsEngine'
import { modals } from './ModalService'

export default function SessionExpiredService() {
    useEffect(() => {
        const unsub = EventsEngine.subscribe(
            'auth:unauthorized',
            'sessionExpiredHandler',
            () => {
                modals.openConfirm({
                    title: 'Your session has expired',
                    children: (
                        <Typography variant='body1' sx={{ mt: 1 }}>
                            Please sign in again to continue using the application
                        </Typography>
                    ),
                    labels: { confirm: 'Sign-in', cancel: 'Cancel' },
                    colors: { confirm: 'warning', cancel: 'primary' },
                    onConfirm: async () => {
                        window.location.reload()
                    }
                })
            }
        )

        return unsub
    }, [])
    return null
}
